<app-base-card [padding]="'1.5rem'">
  <div class="transaction-info">
    <div class="d-flex gap-4">
      <div class="trans-id">{{ transaction.id | leadingZero : 8 }}</div>
      <div class="trans-details">{{ transaction.typeName }}</div>
    </div>
    <div class="trans-details-container">
      <div class="trans-details">{{ transaction.paymentAmount | currency }}</div>
      <div class="trans-details">{{ transaction.postedDate | date : 'MMM d, y' }}</div>
      <button type="button" class="no-style-button view-button" (click)="viewTransactionClick.emit(transaction)" i18n>
        View
        <img [src]="'assets/icons/primary/External Link.svg'" alt="" />
      </button>
    </div>
  </div>
</app-base-card>
